var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"counter"},[(_vm.cardsAmount === 1)?_c('div',[_vm._v(_vm._s(_vm.cardsAmount)+" item")]):_c('div',[_vm._v(_vm._s(_vm.cardsAmount)+" itens")])])
}
var staticRenderFns = []

export { render, staticRenderFns }